module.exports = __webpack_public_path__ + "f2af900da8ba745cff327af3d109ccb9.jpg";